export const processRolePercentages = data => {
  const arr = [];
  for (let i in data) {
    arr.push([i, data[i]]);
  }
  const results = {};
  const sum = arr.map(item => item[1]).reduce((sum, count) => sum + count);
  arr.forEach(item => {
    results[item[0]] = (item[1] * 100) / sum;
  });
  return results;
};
